var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main"},[_c('app-bar',{scopedSlots:_vm._u([{key:"start-content",fn:function(){return [_c('menu-toggle'),_c('logo',{staticClass:"logo",attrs:{"height":'80%'}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }